module.exports = __webpack_public_path__ + "media/images/icons/spotify-64ca654bd9611ab21fc6be690254d126.svg";